import { Link } from 'react-router-dom';

import { env } from '@config/env';
import { PATHS } from '@routes/paths';
import { cn } from '@utils/cn';

export interface LogoMarkProps {
  collapsed?: boolean;
  className?: string;
}

export default function LogoMark({ collapsed, className }: LogoMarkProps) {
  return (
    <Link
      to={PATHS.dashboard}
      className={cn('flex shrink-0 items-center gap-2.5 no-underline', className)}
    >
      <span className="grid h-[34px] w-[34px] shrink-0 place-items-center overflow-hidden rounded-[9px] bg-t1 dark:bg-surface-3">
        <svg width="20" height="20" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <path
            d="M16 2L4 7v9c0 7 5.5 12.5 12 14 6.5-1.5 12-7 12-14V7L16 2z"
            fill="#f0a500"
            fillOpacity="0.15"
          />
          <path
            d="M16 2L4 7v9c0 7 5.5 12.5 12 14 6.5-1.5 12-7 12-14V7L16 2z"
            stroke="#f0a500"
            strokeWidth="1.5"
            fill="none"
          />
          <ellipse cx="16" cy="15" rx="5.5" ry="6.5" fill="#f0a500" />
          <rect x="10.5" y="19" width="11" height="4.5" rx="2" fill="#f0a500" />
          <circle cx="13.5" cy="14" r="1.3" fill="#fff" />
          <circle cx="18.5" cy="14" r="1.3" fill="#fff" />
        </svg>
      </span>
      {collapsed ? null : (
        <span className="overflow-hidden">
          <span className="block whitespace-nowrap font-display text-[14px] font-bold leading-tight tracking-tight text-t1">
            ZeroGhost <span className="text-gold">SHIELD</span>
          </span>
          <span className="block whitespace-nowrap text-[10px] font-medium tracking-[0.02em] text-t3">
            {env.appTagline}
          </span>
        </span>
      )}
    </Link>
  );
}
